import { Component } from '@ecs/Component';

/** Ties a ship entity to its persistent roster entry. */
export class RosterLink implements Component {
  readonly type = 'RosterLink';

  constructor(
    public shipId: number,
    public name: string
  ) {}
}
